export default Object.freeze({
  JA: {text: 'ja', value: 'JA'},
  NEIN: {text: 'nein', value: 'NEIN'},
  UNBEKANNT: {text: 'nicht bekannt', value: 'UNBEKANNT'},
  objects: function () {
    return [this.JA, this.NEIN, this.UNBEKANNT];
  },
});